import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

export const InsufficientCreditsModal = ({ isOpen, onClose, errorDetail }) => {
  const navigate = useNavigate();
  const planType = errorDetail?.plan_type || 'free';
  const code = errorDetail?.code;

  const handleUpgrade = () => {
    onClose();
    navigate('/pricing');
  };

  const isDailyCap = code === 'DAILY_CAP_REACHED';
  const title = isDailyCap ? 'Daily Limit Reached' : 'Usage Limit Reached';
  const description = isDailyCap
    ? errorDetail?.message || 'You have reached your daily analysis limit. It resets at midnight UTC.'
    : "You've used all your included questions and case reviews for this period.";

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md" data-testid="usage-limit-modal">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-yellow-100 rounded-full">
              <AlertCircle className="w-5 h-5 text-yellow-600" />
            </div>
            <DialogTitle>{title}</DialogTitle>
          </div>
          <DialogDescription className="pt-4">{description}</DialogDescription>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="bg-muted rounded-lg p-4">
            <p className="text-sm font-medium mb-2">Current Plan: {planType.charAt(0).toUpperCase() + planType.slice(1)}</p>
            <p className="text-sm text-muted-foreground">
              Upgrade your plan for more agreement questions and case reviews each month.
            </p>
          </div>
        </div>
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="outline" onClick={onClose} className="w-full sm:w-auto" data-testid="usage-limit-cancel">
            Close
          </Button>
          <Button onClick={handleUpgrade} className="w-full sm:w-auto" data-testid="usage-limit-upgrade">
            View Plans
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
